import { useQuery } from 'react-query'
import { axios } from '@/lib/axios'
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query'
import { LiveLotteries } from '../types'
import { ResponseType } from 'axios'

// Main API Response Interface
export interface LotteryApiResponse {
  message: string
  data: Array<Lottery>
  page: number
  limit: number
  totalPages: number
  totalRecords: number
}

// Lottery Data Interface
export interface Lottery {
  _id: string
  lotteryName: string
  ticketPrice: number
  numOfTicketOnSale: number
  numOfTicketSold: number
  startDate: string // ISO Date string
  startTime: string // ISO Time string
  endDate: string // ISO Date string
  endTime: string // ISO Time string
  lotteryDrawDate: string // ISO Date string
  lotteryDrawTime: string // ISO Time string
  totalDraw: number
  drawPrize: number[]
  instruction: string
  maxRpmLotteryWheel: number
  decelarationOfLotteryWheel: number
  maxNumOfTickets: number
  status: boolean
  image: string
  lotteryCurrentStatus: string
  lotteryDrawTktNum: any[] // Array of ticket numbers (if structured, replace `any` with proper type)
  createdBy: string
  lotteryEndTimeStamp: number
  lotteryDrawTimeStamp: number
  notificationTicketAlloc: string
  notificationDrawTime: string
  winEmailNotify: string
  coinRewardAllocated: string
  jackpotSelected: boolean
  createdDate: string // ISO Date string
  updatedDate: string // ISO Date string
  soldStatus: boolean
}

interface UseLotteriesParams {
  page: number
  limit: number
}

export const getLottery = async (
  page: number,
  limit: number
): Promise<LotteryApiResponse> => {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
  try {
    const response = await axios.get<LotteryApiResponse>(
      `/api/v1/user/liveLotteriesData?page=${page}&limit=${limit}`,
      {
        headers: { Timezone: timezone }
      }
    )
    return response.data
  } catch (error: any) {
    // Log or transform error as needed
    if (error.response?.status === 500) {
      console.error('Internal Server Error:', error.response)
    }
    return {
      message:"🛠️ The server is rebooting its brain",
      data: [],
      page: 0,
      limit: 0,
      totalPages: 0,
      totalRecords: 0
    }
  }
}
//Response.data.upc
type QueryFnType = typeof getLottery

type UseLotteriesOptions = {
  config?: QueryConfig<QueryFnType>
  page: number
  limit: number
}

// export const useLotteries = ({ config, page, limit }: UseLotteriesOptions) => {
//   return useQuery<ExtractFnReturnType<QueryFnType>>({
//     queryKey: ['data'],
//     queryFn: () => getLottery(page, limit),
//     ...config,
//   });
// };

export const useLotteries = ({ page, limit }: UseLotteriesParams) => {
  return useQuery(['lotteries', page, limit], () => getLottery(page, limit), {
    keepPreviousData: true, // Optional: Retain data from the previous fetch during transitions
    onError: (error: any) => {
      console.error('Error fetching lotteries:', error.message)
    }
  })
}
